export default __webpack_public_path__ + "static/media/etherscan.534eafba.svg";